import AppComponent from '../../mixins/app-component'

import AppIcon from '../app-icon'
import AppInputEmail from '../app-input-email'
import AppSocialsLinks from '../app-socials-links'

export default
{
    name: 'app-home-slide-5',

    mixins: [
        AppComponent
    ],

    components: {
        AppIcon,
        AppInputEmail,
        AppSocialsLinks
    },

    props: {
        activeIndex: { type: Number, default: 0 },
        activeLevel: { type: Number, default: 0 }
    },

    data() {
        return {
            countdown: {
                daysString: '00',
                daysSplitted: ['0', '0'],
                days: 0,
                hoursString: '00',
                hoursSplitted: ['0', '0'],
                hours: 0,
                minutesString: '00',
                minutesSplitted: ['0', '0'],
                minutes: 0,
                secondsString: '00',
                secondsSplitted: ['0', '0'],
                seconds: 0,
                milliseconds: 0
            }
        }
    },

    created() {
        this.eventHub.$on('app-countdown:update', this.onCountdownUpdate)
        this.eventHub.$on('page-home:onActiveIndexChange', this.onActiveIndexChange)
    },

    mounted() {

    },

    destroyed() {
        this.eventHub.$off('app-countdown:update', this.onCountdownUpdate)
        this.eventHub.$off('page-home:onActiveIndexChange', this.onActiveIndexChange)
    },

    methods: {
        onActiveIndexChange(activeIndex) {
            // TODO
            if (activeIndex !== 5) {
                setTimeout(this._hideErrorMessage, 1000)
            } else {
                this.$el.querySelectorAll('.js-input-email')[0].focus()
            }
        },

        onCountdownUpdate(countdown) {
            this.countdown = countdown
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-home-slide-5/script.js